import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Provider } from 'react-redux';
import { ReactFlowProvider } from 'reactflow';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import store from '@store/index';
import { OpenReplay } from './OpenReplay';
import IntercomWidget from './IntercomWidget';

import 'reactflow/dist/style.css';
import './styles/styles.scss';

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => console.error(error),
  }),
});

root.render(
  <Provider store={store}>
    <ReactFlowProvider>
      <SnackbarProvider
        maxSnack={6}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <QueryClientProvider client={queryClient}>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          <App />
          <IntercomWidget />
          <OpenReplay />
        </QueryClientProvider>
      </SnackbarProvider>
    </ReactFlowProvider>
  </Provider>
);
